// extracted by mini-css-extract-plugin
module.exports = {"fcmModal":"fcmModal_fcmModal__468fX","cover":"fcmModal_cover__pewFr","content":"fcmModal_content__hPTKa","title":"fcmModal_title___psPJ","text":"fcmModal_text__MwmEo"};